<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="order_commissions"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class OrderCommissionDetail extends Vue {
  data = {}

  get columns() {
    return createColumns();
  }

  async mounted() {
    this.data = await this.$request.get(`/order_commissions/${this.$route.params.id}`);
  }
}
</script>
